import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, DialogContent, DialogContentText } from '@material-ui/core';

interface Props {
  open: boolean;
  startGame(): void;
}

class BeginMessage extends Component<Props> {
  handleClose = () => {
    this.props.startGame();
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="begin-message-title"
        aria-describedby="begin-message-description"
        fullWidth={true}
        maxWidth={'md'}
        scroll="paper"
      >
        <DialogTitle id="alert-dialog-title" color="secondary">
          The goal of Linearity is to eliminate all of the items from both
          boxes.
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <strong>Consent Form</strong>
            <br />
            We are asking you to participate in a research study titled
            “Linearity: Teaching Linear Logic Through Games”. We will describe
            this study to you and answer any of your questions. This study is
            being led by Drew Zagieboylo, Department of Computer Science at
            Cornell University. The Faculty Advisor for this study is Erik
            Andersen, Department of Computer Science at Cornell University.
            <br />
            <strong>What the study is about </strong>
            <br />
            The purpose of this research is to understand the effectiveness of
            the game Linearity for learning Linear Logic.
            <br />
            <strong>What we will ask you to do</strong>
            <br />
            We will ask you to take short quizzes on linear logic, play the
            game, and fill out a post-study survey. The in-person portions of
            the study (pre and post gameplay tests) will take no more than 30
            minutes each. We will also ask you to play the game for
            approximately 30 minutes, on your own time.
            <br />
            <strong>Risks and discomforts</strong>
            <br />
            We do not anticipate any risks from participating in this research.
            <br />
            <strong>Benefits</strong>
            <br />
            Information from this study will help us have a better understanding
            on how to integrate logic concepts into games and make the process
            of learning such concepts more engaging for students. There are no
            direct benefits to participants, but participants may indirectly
            benefit from a better understanding of Linear Logic after
            participating in our study.
            <br />
            <strong>Compensation for participation</strong>
            <br />
            There will be no extra compensation for participating in this study.
            <br />
            <strong>Privacy/Confidentiality/Data Security </strong>
            <br />
            No personal identification data will be used in this study, and we
            anticipate that your participation in this survey presents no
            greater risk than everyday use of the Internet. We will record
            information through the game itself (such as how many levels you
            complete) but we will not associate this with your name, only a
            pre-assigned identifier. However, please note that your
            confidentiality will be kept to the degree permitted by the
            technology being used and we cannot guarantee against interception
            of data sent via the internet by third parties.
            <br />
            <strong>
              Sharing De-identified Data Collected in this Research
            </strong>
            <br />
            De-identified data from this study may be shared with the research
            community at large to advance science and health. We will remove or
            code any personal information that could identify you before files
            are shared with other researchers to ensure that, by current
            scientific standards and known methods, no one will be able to
            identify you from the information we share. Despite these measures,
            we cannot guarantee anonymity of your personal data.
            <br />
            <strong>
              Future use of Identifiable Data or Specimens Collected in this
              Research
            </strong>
            <br />
            Your information or biospecimens will not be used or distributed for
            future research studies.
            <br />
            <strong>Taking part is voluntary</strong>
            <br />
            Participation in this study is voluntary, and you may discontinue
            this study at any given time with no penalty.
            <br />
            <strong>Follow up studies</strong>
            <br />
            We may contact you again to request your participation in a follow
            up study. As always, your participation will be voluntary and we
            will ask for your explicit consent to participate in any of the
            follow up studies.
            <br />
            <strong>If you have questions</strong>
            <br />
            The main researcher conducting this study is Drew Zagieboylo, a
            graduate student at Cornell University. Please ask any questions you
            have now. If you have questions later, you may contact Drew
            Zagieboylo at dz333@cornell.edu. If you have any questions or
            concerns regarding your rights as a subject in this study, you may
            contact the Institutional Review Board (IRB) for Human Participants
            at 607-255-5138 or access their website at{' '}
            <a href="http://www.irb.cornell.edu">http://www.irb.cornell.edu</a>.
            You may also report your concerns or complaints anonymously through
            Ethicspoint online at{' '}
            <a href="www.hotline.cornell.edu">www.hotline.cornell.edu</a> or by
            calling toll free at 1-866-293-3077. Ethicspoint is an independent
            organization that serves as a liaison between the University and the
            person bringing the complaint so that anonymity can be ensured.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.startGame} autoFocus color="secondary">
            I agree
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default BeginMessage;
